exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AssessmentQuestionnaireResults_questionnaires_select{margin-bottom:20px;position:absolute;right:0px;top:0px}@media only screen and (max-width: 1200px){.AssessmentQuestionnaireResults_questionnaires_select{position:static}}.AssessmentQuestionnaireResults_check_graph{width:100%;margin-top:40px;margin-bottom:30px}\n", ""]);

// Exports
exports.locals = {
	"questionnaires_select": "AssessmentQuestionnaireResults_questionnaires_select",
	"check_graph": "AssessmentQuestionnaireResults_check_graph"
};